document.addEventListener('DOMContentLoaded', function() {

    // Load more products

    const load_btn = document.querySelector(".custom-filter-load-more");

    let products_on_page = document.querySelector('.collection-grid');
    let url = products_on_page.getAttribute('data-next-url');
    const spinner = document.querySelector('.load-more-spinner');
    const filter_form = document.querySelector('#qf-filter-wrapper form.filter-container');
    const sortBySelect = filter_form.querySelector('#SortBy');
    let checkbox = document.getElementById('toggle-hidden');
    const checkboxMobile = document.getElementById('toggle-hidden-mobile');
    const isMobile = window.innerWidth <= 768;
    const checkboxToCheck = isMobile ? checkboxMobile : checkbox;
    
    if ( sortBySelect ) {
        sortBySelect.addEventListener('change', () => {
            filter_form.submit();
        });
    }
    
    
    if (load_btn) {
        if (url === '') {
            load_btn.style.display = 'none';
        }

        load_btn.addEventListener("click", ()=> {

            spinner.classList.add("show");

            fetch(url)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    } else {
                        throw new Error('Network response was not ok.');
                    }
                })
                .then(function (data) {
                    const html = document.createElement('div');
                    html.innerHTML = data;

                    let links = html.querySelector('.pagination-links').innerHTML;
                    document.querySelector('.pagination-links').innerHTML = links;

                    let new_grid = html.querySelector('.collection-grid');
                    url = new_grid.getAttribute('data-next-url');
                    if (url === '') {
                        load_btn.style.display = 'none';
                    }
                    
                    let current_ads = products_on_page.querySelectorAll("#collection-grid-cta, #collection-grid-cta-2, #collection-grid-cta-3, #collection-grid-cta-4");
                    
                    let visibilityMap = {};
                    
                    current_ads.forEach(current_ad => {
                        let adClass = current_ad.classList[0];
                        let adID = current_ad.id; 
                        let isHidden = window.getComputedStyle(current_ad).display === 'none'; // Check if hidden
                        visibilityMap[adID] = {
                            className: adClass,
                            shouldBeVisible: !isHidden, // Store opposite visibility
                        };
                    });

                    let new_products = new_grid.querySelectorAll(".product-card, #collection-grid-cta, #collection-grid-cta-2, #collection-grid-cta-3, #collection-grid-cta-4");

                    new_products.forEach(new_prod => {
                        let adID = new_prod.id;
                        if (visibilityMap[adID]) {
                            new_prod.style.display = visibilityMap[adID].shouldBeVisible ? 'none' : 'flex';
                        }

                        products_on_page.append(new_prod);

                        ratingBars = new_prod.querySelectorAll('.rating-bar');
                        let newWidth;
                        ratingBars.forEach(ratingBar => {
                            const ratingValue = ratingBar.getAttribute('data-rating');

                            if (!checkboxToCheck.checked) {
                                const productMoreInfo = new_prod.querySelector('.product-more-info');
                                if (isMobile) {
                                    productMoreInfo.classList.add('hidden-mobile');
                                } else {
                                    productMoreInfo.classList.add('hidden-desktop');
                                }
                            }

                            setTimeout(() => {
                                ratingBar.style.setProperty('--rating-width', `${ratingValue}%` );
                              }, 100);
                        });
                    });
                    spinner.classList.remove("show");
                })
                .catch(function (error) {
                    window.log(error);
                });

        })
    }

    const rangeInput = document.querySelectorAll(".range-input input");
    if (rangeInput) {
        const priceInput = document.querySelectorAll(".price-input-show");
        const range = document.querySelector(".slider .progress");
        const minFilterInput = document.querySelector('.min-price-filter');
        const maxFilterInput = document.querySelector('.max-price-filter');
        let priceGap = 1;

        if (maxFilterInput.value != "") {
            range.style.left = ((minFilterInput.value / rangeInput[0].max) * 100) + "%";
            range.style.right = 100 - (maxFilterInput.value / rangeInput[1].max) * 100 + "%";
            rangeInput[0].value = minFilterInput.value;
            rangeInput[1].value = maxFilterInput.value;
            priceInput[0].innerHTML = minFilterInput.value;
            priceInput[1].innerHTML = maxFilterInput.value;
        }

        priceInput.forEach(input => {
            input.addEventListener("input", e => {
                let minPrice = parseInt(priceInput[0].innerHTML);
                let maxPrice = parseInt(priceInput[1].innerHTML);

                if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
                    if (e.target.className === "input-min") {
                        rangeInput[0].value = minPrice;
                        rangeInput[0].setAttribute("data-term", minPrice);
                        range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
                    } else {
                        rangeInput[1].value = maxPrice;
                        maxFilterInput.value = maxVal;
                        range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                    }
                }
            });
        });

        rangeInput.forEach(input => {
            input.addEventListener("input", e => {
                let minVal = parseInt(rangeInput[0].value),
                maxVal = parseInt(rangeInput[1].value);

                if ((maxVal - minVal) < priceGap) {
                    if (e.target.className === "range-min") {
                        rangeInput[0].value = maxVal - priceGap
                    } else {
                        rangeInput[1].value = minVal + priceGap;
                    }
                } else {
                    priceInput[0].innerHTML = minVal;
                    priceInput[1].innerHTML = maxVal;
                    range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
                    range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
                    minFilterInput.value = minVal;
                    maxFilterInput.value = maxVal;
                }
            });
        });
    }

    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el)=>{

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if(control && body){

            control.addEventListener('click', () => {

              console.log("CLICK")

                if(el.classList.contains("open")){
                    el.classList.remove("open")
                } else {
                    el.classList.add("open")
                }

            })
        }
    })

    const mobile_control = document.querySelectorAll(".toggle-mobile-filtering")
    const filter_body = document.querySelector(".custom-filter-wrapper")
    const filter_wrapper = document.querySelector(".filter-container-wrapper")

    if(mobile_control && filter_body){
      mobile_control.forEach(control => {
        control.addEventListener('click', () => {
            console.log("CLICK")
            // rotate svg
            if (control.classList.contains("open")) {
                control.classList.remove("open")
            } else {
                control.classList.add("open")
            }
    
            // open filters
            if (filter_body.classList.contains("open")) {
                filter_body.classList.remove("open")
                filter_wrapper.classList.remove("open")
            } else {
                filter_body.classList.add("open")
                filter_wrapper.classList.add("open")
            }
        })
      })
    }

    // Hide reset filters when no filters active
    const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');

    if (selected_filters_html.length > 0) {
        reset_filters.style.display = 'block';
    }

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            collection_grid.classList.add("loading")
        })
    })

    // Submit form on input change

    // const filter_inputs = document.querySelectorAll('.filter-container-wrapper select, .filter-container-wrapper input:not([id="toggle-hidden"], [id="toggle-hidden-mobile"])');
    // const filter_form = document.querySelector('.filter-container');
    const reset_filter = document.querySelector('#reset-filters');
    const collection_grid = document.querySelector('.collection-grid');

    // filter_inputs.forEach(input => {
    //     input.addEventListener('change', () => {
    //         collection_grid.classList.add("loading")
    //         filter_form.submit()
    //     })
    // })

    reset_filter.addEventListener('click', () => {
        collection_grid.classList.add("loading")
    })

    function updateFiltersFromChooseDevice() {
        const chooseDeviceSelect = document.querySelector('#choose-device select');
        const filterInputs = document.querySelectorAll('.filter-container-wrapper .filter-body input[type="checkbox"]');
        const filter_form = document.querySelector('.filter-container');
  
        if ( chooseDeviceSelect && filterInputs && filter_form ) {
            
            // Set preselected device on the select based on the checked input
            filterInputs.forEach(input => {
                if (input.checked && input.value.includes('filter-device-')) {
                    chooseDeviceSelect.value = input.value;
                }
            });
            
            chooseDeviceSelect.addEventListener('change', () => {
                const selectedValue = chooseDeviceSelect.value;
                filterInputs.forEach(input => {
                    if (input.value.includes('filter-device-')) {
                        input.checked = false;
                    }
                    if (input.value === selectedValue) {
                        input.checked = true;
                    }
                });
                filter_form.submit();
            });
            
        }
    }
  
    updateFiltersFromChooseDevice();

    function countColourSwatches() {
      const productCards = document.querySelectorAll('.product-card');

      productCards.forEach((productCard) => {
        const colorSwatches = productCard.querySelector('.color-selection');
        const moreColours = productCard.querySelector('.more-colors');
        if (colorSwatches) {
          let count = 0;
          for (let i = 0; i < colorSwatches.children.length; i++) {
            count++;
          }
          if (count > 4) {
            moreColours.querySelector('span').innerHTML = count - 4;
            moreColours.classList.remove('hidden');
          }
        }
      });
    }

    countColourSwatches();  

    const deviceSelector = document.querySelector('#choose-device select');

    const productCardHover = () => {
        const productsCards = document.querySelectorAll('.product-card');
    
        productsCards.forEach((productsCard) => {
            let productCardHoverImg;
    
            // Determine the hover image
            if (deviceSelector) {
                const selectedOption = deviceSelector.options[deviceSelector.selectedIndex];
                const hasSelectedDevice = !selectedOption.defaultSelected;
                productCardHoverImg = hasSelectedDevice
                    ? productsCard.dataset.variant_hover_image || productsCard.dataset.product_hover_image
                    : productsCard.dataset.product_hover_image;
            } else {
                productCardHoverImg = productsCard.dataset.collection_device
                    ? productsCard.dataset.variant_hover_image || productsCard.dataset.product_hover_image
                    : productsCard.dataset.product_hover_image;
            }
    
            // If a hover image exists, attach event listeners
            if (productCardHoverImg) {
                const productImg = productsCard.querySelector('.product-image img');
                const productImgSrc = productImg.src;
    
                productsCard.addEventListener('mouseenter', () => {
                    productImg.src = productCardHoverImg;
                });
    
                productsCard.addEventListener('mouseleave', () => {
                    productImg.src = productImgSrc;
                });
            }
        });
    };
    
    productCardHover();
    
})
